(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["url-cart-attributes"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-url-cart-attributes]');
    if (!root) return;

    var cartUrl = root.getAttribute('data-cart-url');
    var updateUrl = root.getAttribute('data-cart-update-url');
    var prefix = 'ca_';
    var allowlist = { exclusive_promo: true };
    var blocked = { language: true };
    var params = new URLSearchParams(window.location.search);
    var incoming = {};

    params.forEach(function (value, key) {
      var attributeKey = null;

      if (key.indexOf(prefix) === 0) {
        attributeKey = key.slice(prefix.length);
      } else if (allowlist[key]) {
        attributeKey = key;
      }

      if (!attributeKey || blocked[attributeKey] || attributeKey.indexOf('dft_') === 0) return;
      if (!/^[a-zA-Z0-9_-]{1,64}$/.test(attributeKey)) return;

      value = String(value).trim().slice(0, 255);
      if (!value) return;

      incoming[attributeKey] = value;
    });

    if (Object.keys(incoming).length === 0) return;

    fetch(cartUrl, { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;

        var current = cart.attributes || {};
        var updates = {};

        Object.keys(incoming).forEach(function (key) {
          if (String(current[key] || '') !== incoming[key]) {
            updates[key] = incoming[key];
          }
        });

        if (Object.keys(updates).length === 0) return;

        return fetch(updateUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: updates })
        });
      })
      .catch(function () {});
  })();
  } catch(e) { console.error(e); }
})();

})();
